import React from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useConsent } from "../lib/consent";
import CookiePreferences from "./CookiePreferences";

// Mounted once in App. Closing the preferences modal never records consent.
export default function CookieConsent() {
  const { hasDecided, prefsOpen, acceptAll, rejectOptional, openPreferences } = useConsent();
  const showBanner = !hasDecided && !prefsOpen;

  return (
    <>
      {showBanner && (
        <div
          role="region"
          aria-label="Cookie consent"
          data-testid="cookie-banner"
          className="cookie-banner fixed z-[60] bottom-4 left-4 right-4 sm:right-auto sm:max-w-md bg-white border border-black/10 rounded-2xl shadow-[0_12px_40px_rgba(0,0,0,0.18)] p-5"
        >
          <div className="flex items-center gap-3">
            <span className="flex items-center justify-center w-9 h-9 rounded-full bg-black text-white shrink-0" aria-hidden="true">
              <Cookie className="w-5 h-5" />
            </span>
            <h2 className="text-lg font-semibold">We value your privacy</h2>
          </div>
          <p className="text-sm text-black/70 mt-3 leading-relaxed">
            We use cookies to ensure our website works properly, remember your preferences, and understand how visitors use our platform. You can accept all cookies or customize your preferences.{" "}
            <Link to="/privacy" className="underline hover:text-black">Privacy Policy</Link>
          </p>
          <div className="grid grid-cols-2 gap-2 mt-4">
            <button type="button" className="btn-filled" onClick={acceptAll} data-testid="cookie-accept">Accept All</button>
            <button type="button" className="btn-filled" onClick={rejectOptional} data-testid="cookie-reject">Reject Optional</button>
            <button type="button" className="btn-outline col-span-2" onClick={openPreferences} data-testid="cookie-customize">Customize</button>
          </div>
        </div>
      )}
      <CookiePreferences />
    </>
  );
}
